import { BaseConfiguration } from "./base-configuration";

/**
 * Customer configuration specific to ewallet
 */

export interface EWalletConfiguration extends BaseConfiguration {
  paymentGateway: PaymentGateway;
  debitCardOnly: boolean;
  slimCDConfiguration?: SlimCDConfiguration;
  applePayConfiguration?: ApplePayConfiguration;
  authorizeNetConfiguration?: AuthorizeNetConfiguration;
  accountTypes?: Record<string, AccountTypeGatewayConfiguration>;
}

/**
 * Gateway configuration for a specific account type
 */
export interface AccountTypeGatewayConfiguration {
  /**
   * The payment gateway to use for this account type (TSYS, SlimCD, Authorize.Net)
   */
  paymentGateway?: PaymentGateway;

  /**
   * TSYS-specific configuration for this account type
   */
  tsysConfiguration?: TsysConfiguration;

  /**
   * SlimCD-specific configuration for this account type
   */
  slimCDConfiguration?: SlimCDConfiguration;

  /**
   * Authorize.Net-specific configuration for this account type
   */
  authorizeNetConfiguration?: AuthorizeNetConfiguration;

  /**
   * Whether this account type only supports debit cards
   */
  debitCardOnly: boolean;
}

export interface TsysConfiguration {
  deviceID: number;
  manifest: string;
}

interface SlimCDConfiguration {
  publicApiCredential: string;
  clientId: string;
}

interface ApplePayConfiguration {
  merchantIdentifier: string;
}

interface AuthorizeNetConfiguration {
  clientKey: string;
  apiLoginId: string;
}

export enum PaymentGateway {
  None = 0,
  TSys = 1,
  SlimCD = 2,
  AuthorizeNet = 3,
}
